var $ = require('jquery');

$(function(){

  var pathName = location.pathname;
  var pageName = pathName.replace('/', '');

  if(pageName == 'trimming') {
    $content = $('.pg-Trimming__content');
    $role = $("[data-role=trimmingPage]");

  } else if(pageName == 'hotel') {
    $content = $('.pg-Hotel__content');
    $role = $("[data-role=hotelPage]");
  }

  var pages,
      $content,
      $role;

  function urlChangeHandler() {
    $('.js-PageNav a').removeClass('is-Current');
    var pageid = parseUrl(location.hash);

    // Navにカレントclass追加
    var elm = $('.js-PageNav a');
    elm.each(function(key, val){
      if( $(this).data('name') == pageid ) {
        $(this).addClass('is-Current');
      }
    });

    $pages
      .detach()
      .removeClass('is-View')
      .filter('.' + pageid)
      .appendTo($content);

    setTimeout(function(){
      $pages.addClass('is-View');
    }, 10);

  }

  function parseUrl(url) {
    return url.slice(1) || 'about';
  }

  function init() {
    $pages = $role.detach();
    $(window).on("hashchange", urlChangeHandler).trigger("hashchange");

  }

  if(pageName == 'trimming' || pageName == 'hotel') {

    init();

  }

});


